export enum EDashboardType {
  MONOSITE = "MONOSITE",
  MULTISITE = "MULTISITE",
}
